import { atom } from 'recoil';
import { IMatrixMemberDirectoryEntry, IMatrixRoomSummary } from './types';

export const aMatrixRoomSummaries = atom<IMatrixRoomSummary[]>({ key: 'aMatrixRoomSummaries', default: [] });
export const aMatrixOpenRoomId = atom<string | null>({ key: 'aMatrixOpenRoomId', default: null });
export const aMatrixMemberDirectory = atom<IMatrixMemberDirectoryEntry[]>({ key: 'aMatrixMemberDirectory', default: [] });
